import type { FinancialAccount, DataAwareResponse } from "@/types/types";
import { axiosInstance } from "@helpers/axios-instance";
import { useQueryWithValidation } from "./useQueryWithValidation";

type AHEWrapper = {
  nonBankAccounts?: FinancialAccount[];
  bankAccounts?: FinancialAccount[];
};

export function useAccountsHeldElsewhere(householdExternalCode: string) {
  return useQueryWithValidation({
    queryKey: ["accounts-held-elsewhere", householdExternalCode],
    queryFn: async () => {
      const data = await axiosInstance({
        method: "GET",
        url:
           `Salesforce/AccountsHeldElsewhere/${householdExternalCode}`,
      });
      return data.data as DataAwareResponse<AHEWrapper>;
    },
    enabled: !!householdExternalCode,
  });
}
